module.exports = __webpack_public_path__ + "img/thenews.im.a6299b2e.png";